// Lib
import { LINKEDIN } from '@/lib/socialProfile';
import { getPostType, LI_POST_TYPES } from '@/lib/posts/postTypes';
import type { LIPostTypesType } from '@/lib/posts/postTypes';
import { LiPostIcons } from '@/lib/albums/albumCardIconType';

// Hooks
import { useTransformStringOnOffset } from '@/utils/hooks/format/useTransformString';

// Components
import Post from '@/components/base/Post';
import { AlbumPostIcon } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/AlbumPostIcon';

type LinkedinAlbumPostProps = {
    data: {
        type: LIPostTypesType;
        caption_formatted?: string;
        tags: { link: string }[];
        medias: { image?: string; thumbnail: string }[];
    };
    shouldDisplayIcon: boolean;
};

const LinkedinAlbumPost = ({ data, shouldDisplayIcon }: LinkedinAlbumPostProps) => {
    const { OffsetReplace } = useTransformStringOnOffset();

    const type = getPostType({
        network: LINKEDIN,
        type: data?.type,
        mediasLength: data?.medias?.length
    });

    return (
        <Post data={data} className="w-full">
            <Post.Content className="relative w-full text-left text-sm">
                <AlbumPostIcon
                    show={type && type !== LI_POST_TYPES.TYPE_STATUS && shouldDisplayIcon}
                    type={LiPostIcons[type]}
                />
                <Post.Status
                    withMedia={
                        type !== LI_POST_TYPES.TYPE_STATUS &&
                        type !== LI_POST_TYPES.TYPE_LINK &&
                        type !== LI_POST_TYPES.TYPE_POLL &&
                        type !== LI_POST_TYPES.TYPE_VIDEO
                    }
                    remoteMedia={true}
                    formattedCaption={
                        <OffsetReplace
                            text={data?.caption_formatted}
                            components={Object.assign(
                                {
                                    a: <span className="text-icoBlue" />,
                                    br: <br />
                                },
                                data?.tags?.map((tag, id) => (
                                    // eslint-disable-next-line jsx-a11y/anchor-has-content
                                    <a
                                        key={id}
                                        href={tag.link}
                                        className="text-icoBlue"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ))
                            )}
                        />
                    }
                />
            </Post.Content>
        </Post>
    );
};

export default LinkedinAlbumPost;
